export default defineNuxtPlugin((nuxtApp) => {
  // Register a no-op directive on both sides to avoid Vue "Failed to resolve directive" warnings.
  nuxtApp.vueApp.directive('animate', {})

  // Client-only logic
  if (process.client) {
    const validClasses = ['fadeIn', 'fadeInUp', 'fadeInLeft', 'fadeInRight', 'scaleIn']

    const sharedObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible')
            sharedObserver.unobserve(entry.target)
          }
        })
      },
      {
        threshold: 0,
        rootMargin: '50px 0px 50px 0px',
      }
    )

    const observeElement = (el) => {
      if (el && !el.classList.contains('is-visible')) {
        sharedObserver.observe(el)
      }
    }

    // Real directive: adds CSS classes and observes the element.
    nuxtApp.vueApp.directive('animate', {
      mounted(el, binding) {
        const animationClass = binding.value || 'fadeInUp'
        const className = validClasses.includes(animationClass)
          ? `animate-${animationClass}`
          : 'animate-fadeInUp'
        el.classList.add('scroll-animate', className)
        observeElement(el)
      },
      unmounted(el) {
        sharedObserver.unobserve(el)
      },
    })

    // Fallback: scan the whole document after app mounts.
    const initAnimations = () => {
      document.querySelectorAll('.scroll-animate:not(.is-visible)').forEach((el) => {
        observeElement(el)
      })
    }

    nuxtApp.hook('app:mounted', () => {
      if (document.readyState === 'complete') {
        requestAnimationFrame(initAnimations)
      } else {
        window.addEventListener('load', () => requestAnimationFrame(initAnimations))
      }
    })
  }
})
